import type { RouteConfigExtended } from '@lingoda/router';
import {
    postCheckoutBookClassPath,
    postCheckoutChangeLanguageCheckoutPath,
    postCheckoutChangeLanguageStorePath,
    postCheckoutConfirmLanguagePath,
    postCheckoutCongratulationsPath,
    postCheckoutCreditsTypeSelectionPath,
    postCheckoutLanguagesYouSpeakPath,
    postCheckoutLanguagesYouSpeakThanksPath,
    postCheckoutLearningFocusAreaPath,
    postCheckoutLearningFocusAreaSuccessPath,
    postCheckoutLearningGoalsPath,
    postCheckoutLearningGoalsSuccessPath,
    postCheckoutOnboardingSurveyPath,
    postCheckoutPath,
    postCheckoutProficiencyFindYourLevelPath,
    postCheckoutProficiencyLevelPath,
    postCheckoutProficiencyPath,
    postCheckoutProficiencySubLevelPath,
    postCheckoutProficiencySummaryPath,
    postCheckoutSuccessLanguageChangePath,
    postCheckoutTimeSlotsPath,
    postCheckoutWelcomePath,
} from '@lingoda/router';
import {
    PostCheckoutRoot,
    Proficiency,
    Welcome as WelcomePage,
} from '@lingoda/student-post-checkout';
import {
    BookClassPage,
    ChangeLanguageCheckoutPage,
    ChangeLanguageStorePage,
    ConfirmLanguagePage,
    CongratulationsPage,
    CreditsTypeSelectionPage,
    LanguagesYouSpeakPage,
    LanguagesYouSpeakThanksPage,
    LearningFocusAreaPage,
    LearningFocusAreaSuccessPage,
    LearningGoalSuccessPage,
    LearningGoalsPage,
    OnboardingSurveyPage,
    ProficiencyPage,
    SuccessLanguageChangePage,
    TimeSlotsPage,
} from './pages';

export const postCheckoutAppRoutes: RouteConfigExtended[] = [
    {
        component: PostCheckoutRoot,
        path: postCheckoutPath.raw,
        label: 'PostCheckout',
        config: {
            hideFooter: true,
            hideMobileBottomNavbar: true,
            hideHeader: true,
            tab: undefined,
        },
        routes: [
            {
                component: ConfirmLanguagePage,
                label: 'ConfirmLanguage',
                path: postCheckoutConfirmLanguagePath.raw,
                config: { hideFooter: true, hideMobileBottomNavbar: true, hideHeader: true },
            },
            {
                component: OnboardingSurveyPage,
                label: 'OnboardingSurvey',
                path: postCheckoutOnboardingSurveyPath.raw,
                config: { hideFooter: true, hideMobileBottomNavbar: true, hideHeader: true },
            },
            {
                component: ChangeLanguageStorePage,
                label: 'ChangeLanguageStore',
                path: postCheckoutChangeLanguageStorePath.raw,
                config: { hideFooter: true, hideMobileBottomNavbar: true, hideHeader: true },
            },
            {
                component: ChangeLanguageCheckoutPage,
                label: 'ChangeLanguageCheckout',
                path: postCheckoutChangeLanguageCheckoutPath.raw,
                config: { hideFooter: true, hideMobileBottomNavbar: true, hideHeader: true },
            },
            {
                component: SuccessLanguageChangePage,
                label: 'SuccessLanguageChange',
                path: postCheckoutSuccessLanguageChangePath.raw,
                config: { hideFooter: true, hideMobileBottomNavbar: true, hideHeader: true },
            },
            {
                component: LearningGoalsPage,
                label: 'LearningGoals',
                path: postCheckoutLearningGoalsPath.raw,
                config: { hideFooter: true, hideMobileBottomNavbar: true, hideHeader: true },
            },
            {
                component: LearningGoalSuccessPage,
                label: 'LearningGoalSuccess',
                path: postCheckoutLearningGoalsSuccessPath.raw,
                config: { hideFooter: true, hideMobileBottomNavbar: true, hideHeader: true },
            },
            {
                component: LearningFocusAreaPage,
                label: 'LearningFocusArea',
                path: postCheckoutLearningFocusAreaPath.raw,
                config: { hideFooter: true, hideMobileBottomNavbar: true, hideHeader: true },
            },
            {
                component: LearningFocusAreaSuccessPage,
                label: 'LearningFocusAreaSuccess',
                path: postCheckoutLearningFocusAreaSuccessPath.raw,
                config: { hideFooter: true, hideMobileBottomNavbar: true, hideHeader: true },
            },
            {
                component: LanguagesYouSpeakPage,
                label: 'LanguagesYouSpeak',
                path: postCheckoutLanguagesYouSpeakPath.raw,
                exact: true,
                config: {
                    hideFooter: true,
                    hideMobileBottomNavbar: true,
                    hideHeader: true,
                },
            },
            {
                component: LanguagesYouSpeakThanksPage,
                label: 'LanguagesYouSpeakThanks',
                path: postCheckoutLanguagesYouSpeakThanksPath.raw,
                exact: true,
                config: {
                    hideFooter: true,
                    hideMobileBottomNavbar: true,
                    hideHeader: true,
                },
            },
            {
                component: ProficiencyPage,
                label: 'SelectProficiency',
                path: postCheckoutProficiencyPath.raw,
                config: {
                    hideFooter: true,
                    hideMobileBottomNavbar: true,
                    hideHeader: true,
                },
                routes: [
                    {
                        component: Proficiency.FindYourLevel,
                        path: postCheckoutProficiencyFindYourLevelPath.raw,
                        config: {
                            hideFooter: true,
                            hideMobileBottomNavbar: true,
                            hideHeader: true,
                        },
                    },
                    {
                        exact: true,
                        component: Proficiency.Level,
                        path: postCheckoutProficiencyLevelPath.raw,
                        config: {
                            hideFooter: true,
                            hideMobileBottomNavbar: true,
                            hideHeader: true,
                        },
                    },
                    {
                        exact: true,
                        component: Proficiency.SubLevel,
                        path: postCheckoutProficiencySubLevelPath.raw,
                        config: {
                            hideFooter: true,
                            hideMobileBottomNavbar: true,
                            hideHeader: true,
                        },
                    },
                    {
                        exact: true,
                        component: Proficiency.Summary,
                        path: postCheckoutProficiencySummaryPath.raw,
                        config: {
                            hideFooter: true,
                            hideMobileBottomNavbar: true,
                            hideHeader: true,
                        },
                    },
                ],
            },
            {
                component: TimeSlotsPage,
                label: 'TimeSlots',
                path: postCheckoutTimeSlotsPath.raw,
                config: {
                    hideFooter: true,
                    hideMobileBottomNavbar: true,
                    hideHeader: true,
                },
            },
            {
                component: BookClassPage,
                label: 'BookClass',
                path: postCheckoutBookClassPath.raw,
                config: {
                    hideFooter: true,
                    hideMobileBottomNavbar: true,
                    hideHeader: true,
                },
            },
            {
                component: CreditsTypeSelectionPage,
                label: 'CreditsTypeSelection',
                path: postCheckoutCreditsTypeSelectionPath.raw,
                config: {
                    hideFooter: true,
                    hideMobileBottomNavbar: true,
                    hideHeader: true,
                },
            },
            {
                component: CongratulationsPage,
                label: 'CongratulationsPage',
                path: postCheckoutCongratulationsPath.raw,
                config: {
                    hideFooter: true,
                    hideMobileBottomNavbar: true,
                    hideHeader: true,
                },
            },
            {
                component: WelcomePage,
                label: 'WelcomePage',
                path: postCheckoutWelcomePath.raw,
                config: {
                    hideFooter: true,
                    hideHeader: true,
                    tab: undefined,
                    hideNavigation: true,
                    navigationElevation: 1,
                },
            },
        ],
    },
];
